<template>
    <div id="LogNotesNursesList">
        <LeftBaseView :MdTitle="'Log Notes'" @getVisibleMenu="$emit('getVisibleMenu', $event)">
            <template v-slot:content>
                <LogNoteList :ShowBar="false" :OpenedFromTheNurses="true"></LogNoteList>
            </template>
        </LeftBaseView>
    </div>
</template>

<script>
import LogNoteList from '@/components/pages/clinical/lognotes/LogNotesList.vue'

export default {
  name: 'LogNotesNurseList',
  props:{

  },
  components:{LogNoteList},
  data(){
    return {
        OptionsRightMenu:{
            visible:false,
            btnLogNoteNurseVisible:false,
            ItemsList:[],
            btnGroupNotesvisible:false,
            btnIncidentWorkflowvisible:false,
            btnDrugOrdersInboxvisible:false,
            btnPatientsPortalDashboardVisible:false,
            btnvisible:false,
            itemdisabled: false,

        },
    }
  },

  computed:{

  },

  methods:{

  },

  created(){

  },

  mounted(){
    this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R0':
                this.$store.commit('setlayoutStatus', 'L0R1');
                break;
            default:
                this.$store.commit('setlayoutStatus', 'L1R1');
        }

		this.$emit('getVisibleMenuLogNotes', this.OptionsRightMenu);
  }

};
</script>


